export const newRequestState = (state, fieldName, extras = {}) => ({
	...state,
	loading: {
		...state.loading,
		[fieldName]: true,
	},
	...extras,
});
export const newSuccessState = (state, fieldName, newValue, extras = {}) => ({
	...state,
	[fieldName]: newValue,
	loading: {
		...state.loading,
		[fieldName]: false,
	},
	error: {
		...state.error,
		[fieldName]: "",
	},
	...extras,
});
export const newErrorState = (
	state,
	fieldName,
	error,
	fieldDefaultValue = {},
	extras = {},
) => ({
	...state,
	[fieldName]: fieldDefaultValue,
	loading: {
		...state.loading,
		[fieldName]: false,
	},
	error: {
		...state.error,
		[fieldName]: error || "An error occurred, please try again later.",
	},
	...extras,
});
